import { RequestResponse } from '../../../../../core/application/http-response/http-response';
import {
  HttpClient,
  HttpMethod
} from '../../../../../core/application/protocols/http-client';
import { ServiceCommand } from '../../../../../core/domain/command/service-command';
import { error, success } from '../../../../../core/domain/either/either';
import { SubscriptionModel } from '../../domain/models/subscriptions/create-subscription-model';

export class GetSubscriptionByCompanyId
  implements ServiceCommand<GetSubscriptionByCompanyId.Response>
{
  constructor(
    private readonly httpClient: HttpClient<GetSubscriptionByCompanyId.Response>,
    private readonly url: string
  ) {}

  async execute(
    params: GetSubscriptionByCompanyId.Params
  ): Promise<ServiceCommand.Response<GetSubscriptionByCompanyId.Response>> {
    const httpResponse = await this.httpClient.request({
      method: HttpMethod.GET,
      url: `${this.url}/${params.companyId}`
    });

    const responseOrError = RequestResponse.handle(httpResponse);

    if (responseOrError.isError()) {
      return error(responseOrError.value);
    }
    const response = responseOrError.value.response;

    return success(response);
  }
}

export namespace GetSubscriptionByCompanyId {
  export type Params = { companyId: string };

  export type Response = SubscriptionModel;
}
